// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IActionButtonV2Schema {
  /** Ссылка по которой надо перейти в случае выбора этого варианта ответа **/
  link?: string;
  /** Название маркетинговой кампании для аналитики **/
  promoName: string;
  /** Вариант который надо отправить по socket-у **/
  socketPayload?: string;
  /** Текст ссылки или текст варианта ответа **/
  text: string;
  /**
   *
   *     Тип ответа.
   *     Если ссылка deeplink, то обязательно должно быть поле link.
   *     Если вариант ответа который надо вернут по socket, то обязательно должно быть поле socketPayload.
   *
   */
  type: EType;
}

export enum EType {
  /** Диплинк **/
  'Deeplink' = 'deeplink',
  /** Сокет **/
  'Socket' = 'socket',
}
